export const JADWAL_KAPAL_URL = 'dashboard/jadwal_kapal'
export const JADWAL_KAPAL_ERROR = 'JADWAL_KAPAL_ERROR'
export const JADWAL_KAPAL_LOADING = 'JADWAL_KAPAL_LOADING'
export const JADWAL_KAPAL_SUCCESS = 'JADWAL_KAPAL_SUCCESS'